$(function () {
	$('#active').on('change', function () {
		let activeId = this.options[this.selectedIndex].value;
		let allOptions = $('.active--option');

		// reset fields
		allOptions.addClass('hide');
		$('.js-reset').prop('checked', false);
		_reductionReset();
		_activeTimeReset();

		if(activeId === '1') {
			$('.active--option-reduction').removeClass('hide');
		}

		if(activeId === '4') {
			$('.active--option-activeTime').removeClass('hide').find('.custom-control-input').attr('required', 'required');
			$('#becomeMemberActiveDescription').attr('required', 'required');
		}
	});

	// step 2 - reduction
	$('#becomeMemberReduction').on('click', function () {
		if ($(this).prop('checked')) {
			$('.reduction--content').removeClass('hide');
			$('#becomeMemberPensum').attr('required', 'required');
			$('#salaryUpload1').attr('required', 'required');

		} else {
			_reductionReset();
		}
	});

	// step 3 - camvet content
	$('#division-15').on('click', function () {
		if ($(this).prop('checked')) {
			$('.camvet-content').removeClass('hide').find('.custom-control-input').attr('required', 'required');
		} else {
			$('.camvet-content').addClass('hide').find('.custom-control-input').removeAttr('required').prop('checked', false);
		}
	});
});

function _reductionReset() {
	$('.reduction--content').addClass('hide').find('.custom-file-input').removeAttr('required').val('');
	$('#becomeMemberPensum').removeAttr('required').val('');
	$('#becomeMemberReductionDescription').val('');
	$('.reduction--content').find('.control-label-inside').removeClass('animate-label');
}

function _activeTimeReset() {
	$('#becomeMemberActiveDescription').removeAttr('required').val('');
	$('.active--option-activeTime').find('.control-label-inside').removeClass('animate-label');
	$('.active--option-activeTime').find('.custom-control-input').removeAttr('required');
}
